<div class="w-full h-screen flex justify-center items-center">
  <app-pan-card
    [header]="state() === LpHomeState.ValidatingRole ? 'Loss Prevention' : ''"
    [subheader]="state() === LpHomeState.ValidatingRole ? 'Welcome to Loss Prevention Portal' : ''"
  >
    <div role="status" class="flex items-center gap-2">
      <div class="space-y-2">
        @switch (state()) {
          @case (LpHomeState.Authentication) {
            <div class="flex items-center gap-2" data-testid="authenticating">
              <app-pan-spinner></app-pan-spinner>
              <span>Authenticating...</span>
            </div>
          }
          @case (LpHomeState.ValidatingRole) {
            <div class="flex items-center gap-2">
              <app-pan-spinner></app-pan-spinner>
              <span>Loading...</span>
            </div>
          }
          @case (LpHomeState.Error) {
            <app-pan-inline-alert type="danger">
              {{ errorMessage() }}
            </app-pan-inline-alert>
          }
        }
      </div>
    </div>
  </app-pan-card>
</div>
